<template>
  <div class="json-editor scroll-vertical">
    <text-editor
      v-if="jsonText"
      :text="jsonText"
      v-on:update:textUpdate="config = $event"
      :lineNumbers="true"
      class="editor">
    </text-editor>
  </div>
</template>

<script>
import TextEditor from '@/components/TextEditor.vue';

export default {
  name: 'AlertJson',
  components: {
    TextEditor,
  },
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  computed: {
    jsonText() {
      return JSON.stringify(JSON.parse(this.data), null, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.json-editor {
  width: 100%;
  height: 100%;
  // Added this becuase it is getting cut off when there is a tab-bar on top of it
  padding-bottom: 4.75rem;
}
</style>
